import { post } from '@/lib/api/http';

interface SubscribeResponse {
  success: boolean;
}

export async function subscribeToNewsletter(email: string): Promise<SubscribeResponse> {
  const response = await post<SubscribeResponse, { email: string }>('/contact/subscribe', { email });
  return response.data.body;
}
